/**
 * You can register global mixins here
 */
import { mapState, mapGetters, mapActions } from "vuex";
import moment from 'moment'

const GlobalMixins = {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          cartCheckerInterval: null
        }
      },
      computed: {
        ...mapState('cartStore', ['newCart', 'expires_at']),
        ...mapState('userStore', ['user']),
        ...mapGetters('userStore', ["isAuthenticated"]),
      },
      mounted() {
        let { bodyClass } = this.$options;
        if (bodyClass) {
          document.body.classList.add(bodyClass);
        }
      },
      methods: {
        ...mapActions('cartStore', ['clearNewCart']),
        checkCartExpiration() {
          if (moment(this.expires_at).isBefore(moment().format())) {
            this.clearNewCart()
            this.$router.push({name:'home'})
          }
        }
      },
      beforeDestroy() {
        let { bodyClass } = this.$options;
        if (bodyClass) {
          document.body.classList.remove(bodyClass);
        }
        clearInterval(this.cartCheckerInterval);
      },

    });
  }
};

export default GlobalMixins;
